export default function Privacy() {
  return (
    <>
      <h2>Privacy Policy</h2>
      <p> Last Updated: 4/12/22</p>

        <h3>Overview</h3>
        <p>Flashcards takes user privacy seriously. This Policy describes how we handle information collected in
          relation
          to access and use of flashcards.cookiebrains.com (the “Site”). When you access or use the Site, you are deemed
          to consent to the collection, use, retention, transfer, structuring, manipulation, storage, transmission
          and/or
          disclosure (collectively, “processing”) of your information as described in this Policy and in accordance with
          applicable laws.</p>
        <p>This Policy does not govern what our users do on their own decks (i.e. custom flashcard decks that people
          make
          using the Site.)</p>
        <p>This Policy also does not apply to websites or services you might access through links or other features
          (e.g.,
          YouTube videos, Twitter buttons) on the Site. These other services have their own privacy policies, and we
          encourage you to review them before providing them with personal information.</p>

        <h3>Information you give us</h3>
        <p>We may ask for and collect the following personal information about you when you use the Site. This
          information
          is necessary for the adequate performance of the contract between you and us, for our legitimate interest in
          being able to provide and improve the Site, and to allow us to comply with our legal obligations. Without it,
          we
          may not be able to provide the Site as intended.</p>

        <h4>Account and Profile Information</h4>
        <p>When you create an account, we require you to provide us information such as your username, password, and
          email
          address. This information is used for confirming your identity and providing access to the Site.</p>

        <h4>Contact Information</h4>
        <p>When you contact us via our chat and email channels, you may provide us, in addition to the content of your
          message, your name and email address. When you contact us for support or feedback, your information is used
          solely to respond to your request. We do not use your information for marketing.</p>
        <h4>Information About Your Accounts on Third-Party Services</h4>
        <p>Flashcards provides the ability to log in to the Service using your Google, or Microsoft account. If you
          authenticate yourself using any of these services, you grant us access to your email address, and, if
          available, your name, photo, and username associated with them. We do not receive your password.</p>

        <h4>Payment Information</h4>
        <p>When you use a service that requires payment, we collect your name, email, and credit card information for
          the purpose of billing and charging you. Your payment information is stored in a PCI compliant way.</p>

        <h3>Information We Track Automatically</h3>
        <p>When you use the Site, we may automatically collect information, including personal information, about you
          and how you use the Site. This information is necessary for the adequate performance of the contract between
          you and us, to enable us to comply with legal obligations and given our legitimate interest in being able to
          provide and improve the Site.</p>
        <p>If you use Flashcards on different devices, we may associate and combine the information we collect from
          those different devices to help us provide a consistent service across your different devices. If we do
          combine any automatically-collected information with personal information, we will treat the combined
          information as personal information, and it will be protected as per this Policy.</p>

        <h4>Information Collected Using Cookies</h4>
      Cookies are data that a website can store on a user’s web browser for a duration of time. Every website stores
        its own set of cookies and, by design, one website cannot read the cookies of another website.
        Flashcards cookies are used to:
      <br/>• authenticate users
      <br/>• keep users logged in while they use the Site
      <br/>• track user behavior on the Site (e.g. which page the user visited after the home page)
      <br/>• remember user preferences (e.g. timezone)
      <br/>
      <p>When you share links to external services on a deck, e.g. YouTube, those services may store cookies on your
        browser too. We have no control over the cookies they store and what they do with them.</p>
      
        <h4>Information Related to Your Device</h4>
        We collect device-specific information such as:
      <br/>• device brand, version, and type (e.g. Samsung Galaxy S9 Cellphone)
      <br/>• operating system and version (e.g. Android 8.0)
      <br/>• browser type and version (e.g. Chrome 63.0)
      <br/>• screen size and resolution (e.g. 375px wide retina screen)
      <br/>
      <p>This helps us measure how the Site is performing, improve Flashcards for you on your particular device, and send
        you push notifications if you’ve opted in to receive them.</p>
      
        <h4>Information Related to the Use of the Site</h4>
      <p>We collect information about how people use the Site. This information includes general usage information, and
        may
        include information such as the number and frequency of our visitors, which pages or features of the Site they
        have visited, which links on the Service they have clicked on, and the length of those visits.</p>
        <p>We may also use third party applications and services, such as Google Analytics (GA), to collect, analyze, and
        report this information. We may also use some of this information in aggregate form, that is, as a statistical
        measure related to all of our users that would not identify you personally.</p>
          <p>We use information about your use of the Site to improve and enhance your experience on the Service. We, under
        no
        circumstances, sell or share this data with others.</p>
        <h4>Information Related to Your Location</h4>
        <p>An IP address is an address assigned to any device connected to the Internet. Depending on where you are, your
        IP
        address can be unique to your computer, or shared among many devices. An IP address can be used to locate the
        device it is assigned to, and in turn the user using it.</p>
      <p>When you use the Site, we collect your IP address for:</p>
        • analytics (e.g. how many people from France used Flashcards today)
      <br/>• detecting and preventing spam, malware and content policy violations (e.g. blocking the IP addresses posting
        bad
        links)
      <br/>• detect your country or state for tax purposes if you purchase a membership.
      <br/>We do not store your IP address anywhere on our service for longer than 30 days after your visit. We use Google
        Analytics’ IP anonymization feature to prevent them from associating your activity with your identity. (So, GA
        will only see that someone in San Francisco visited page X, not someone who lives on the corner of 6th St and
        Mission St.)
        <h3>How Long We Retain Information</h3>
      <p>Flashcards will keep information for as long as necessary to provide the Service under our Terms and Conditions
        and other relevant agreements between you and Flashcards. We will also retain information so as to fulfil any
        legal requirement to which we are subject to, e.g. trade, tax, and employment law. We will discard personal
        information when:</p>
      <br/>
        • the data subject withdraws consent to processing,
      <br/>• our contractual obligations have been fully performed and cannot be performed to any further extent, or
      <br/>• the personal information is obsolete.
      <br/> We will also not keep any information the processing of which has been objected to, or for which a request for
        erasure has been made, beyond the legally required timeframe to complete such a request (usually 30 days).
        <h3>Whom Do We Share the Collected Information With?</h3>
        <p>First and foremost, you should know that Flashcards does not sell or rent your personal information to any
          third-party for any purpose.</p>
          <p>We share information we collect from you under the limited circumstances set forth below:</p>
        <h4>Information Shared with Third Parties</h4>
      <p>We may share aggregated information (information about our users that we combine together so that it no longer
        identifies or references an individual user) and other de-identified or non-personally identifiable information,
        with users, partners, press, or other third-parties in order to, for example, demonstrate how Flashcards is
        used,
        spot industry trends, or to provide marketing materials for Flashcards. Any aggregated information and
        non-personalized information shared this way will not contain any personal information.</p>
        <h4>Information Disclosed to Fulfil Legal Obligations</h4>
      <p>We may disclose personal information if necessary to comply with the law, such as complying with a subpoena or
        other legal process. We may need to disclose personal information where, in good faith, we think it is necessary
        to protect the rights, property, or safety of Flashcards, our employees, our community, or others, or to prevent
        violations of our Terms of Service or other agreements. This includes, without limitation, exchanging
        information
        with other companies and organizations for fraud protection or responding to law enforcement and government
        requests.</p>
      <p>Where appropriate, we may notify users about the legal requests, unless (i) providing notice is prohibited by
        the
        legal process itself, by court order we receive, or by applicable law; (ii) we believe that providing notice
        would
        be futile, ineffective, create a risk of injury or bodily harm to an individual or group, or create or increase
        a
        risk of fraud upon Flashcards or its users. In instances where we comply with legal requests without notice for
        these reasons, we will attempt to notify that user about the request after the fact where appropriate and where
        we
        determine in good faith that we are no longer prevented from doing so.</p>
        <h4>Information Disclosed Pursuant to Business Transfers</h4>
      <p>Over time, Flashcards may grow and reorganize. We may share your personal information with affiliates such as a
        parent company, subsidiaries, joint venture partners or other companies that we control or that are under common
        control with us, in which case we will require those companies to agree to use your personal information in a
        way
        that is consistent with this Policy.</p>
      <p>In the event that all or a portion of Flashcards or its assets are acquired by or merged with a third-party,
        personal information that we have collected from users would be one of the assets transferred to or acquired by
        that third-party. This Policy will continue to apply to your information, and any acquirer would only be able to
        handle your personal information as per this Policy (unless you give consent to a new policy). We will provide
        you
        with notice of an acquisition within 30 days following the completion of such a transaction, by posting on our
        homepage, or by emailing you on your email address on file. If you do not consent to the use of your personal
        information by such a successor company, you may request its deletion from the company.</p>
        <p>In the unlikely event that Flashcards goes out of business, or files for bankruptcy, we will protect your
        personal
        information, and will not sell it to any third-party.</p>
        <h4>Information Shared to Enforce Content Policy</h4>
      <p>To make sure that all content on Flashcards conforms to our content policy, we reserve the right to run all
        content, no matter the privacy, through a series of automated checks. If any content is flagged to be in
        violation
        of our content policy, Flashcards authorized personnel may look at it to determine the appropriate action to be
        taken against that content. This helps us keep the Service safe and appropriate for all users.</p>
        <h4>Information You Share with Third Party Services</h4>
        <p>You may access Third Party Services through the Site, for example by watching a YouTube video on a deck. You may
        also choose to share information that you provide to us with Third Party Services (e.g., by posting your decks
        to
        Twitter or Facebook). These services have their own privacy policies which we don’t govern. We encourage you to
        review them before providing them with personal information.</p>
        <h4>Information Shared With Your Consent or at Your Request</h4>
      <p>Other than the cases above, we will share your information only if we have your consent.</p>
        <h3>How We Secure Information</h3>
      <p>The security of your personal information is important to us. We maintain administrative, technical and physical
        safeguards to protect against loss, theft, unauthorized use, disclosure, or retrieval of personal information.
        In
        particular:</p>
      • We perform application security testing; penetration testing; and monitor compliance with security policies
      <br/>• We periodically review our information collection, storage and processing practices, including physical
        security
        measures, to guard against unauthorized access to systems
      <br/>• We continually develop and implement features to keep your personal information safe
      <br/>• When you enter any information anywhere on the Service, we encrypt the transmission of that information using
        transport layer security technology (TLS) by default
      <br/>• We ensure passwords are stored and transferred securely using encryption and salted hashing
      <br/> • The Site is hosted on servers at a third-party facility, with whom we have a contract providing for enhanced
        security measures. For example, personal information is stored on a server equipped with industry standard
        firewalls. In addition, the hosting facility provides a 24x7 security system, video surveillance, intrusion
        detection systems and locked cage areas
      <br/>• We restrict access to personal information to authorized Flashcards employees, agents or independent
        contractors
        who need to know that information in order to process it for us, and who are subject to strict confidentiality
        obligations and may be disciplined or terminated if they fail to meet these obligations
      <br/> • We require subprocessors to comply with security requirements via separate data processing agreements
        If we learn of a security breach, we will attempt to notify you electronically (subject to any applicable laws)
        so
        that you can take appropriate protective steps; for example, we may post a notice on our Site 
      and email to your email address on file. Depending on where you live, you may have a legal right to
        receive notice of a security breach in writing.
        <h3>Deleting Your Account</h3>
        <p>You may delete your Account at any time. You can do so from your Account Settings page on the Site or the App or
        by sending us a request using our support page. If you email us, we may require sufficient identifying
        information
          to be able to determine that you own the account.</p>
      <p>When you delete your account, we delete:</p>
        • your profile information and any other content you provide in your profile (such as your name, username,
        password, email address, and profile photos)
      <br/>• all the decks you have created and all the content posted on them, whether or not that content was created by
        you
      <p>We also do not delete non-identifiable aggregate information about your usage of the service.
        We aim to maintain our services in a manner that protects information from accidental or malicious destruction.
        Because of this, even after you update or delete personal information you have provided us from our Service,
        your
        personal information may be retained in our backup files, archives, and server logs for up to 30 days, unless
        legal obligations require us to retain them for longer periods of time.</p>
        <h3>Your Rights</h3>
        You have the choice to request correction and/or deletion of personal information we process about you as well
        as
        to request that we cease communicating with you where we do so on the basis of your consent or previous customer
        relationship with you. If you are a registered user, you can access and update most information associated with
        your Account by logging in to the Service and checking your Account Settings page.
        <h4>Your GDPR Rights</h4>
        Customers based in the European Union or the European Economic Area shall have the following data subject rights
        in line with the European Union General Data Protection Regulation:
        • Right to withdraw consent for processing of personal information at any time
        • Right to be forgotten or to require deletion or blocking personal data which is incorrect or which has been
        processed illegally
        • Right to restrict or object to certain types of processing of personal information
        • Right to demand the rectification of erroneous or incomplete personal information
        • Right to obtain a copy of personal information in a structured machine-readable format and, on request, to
        transmit personal data to other data controllers
      <h4>Your California Privacy Rights</h4>
        Under the California Consumer Privacy Act, you are entitled to a copy of the data you have provided to us by
        sending a mail to privacy@cookiebrains.com.
        Under California Civil Code sections 1798.83-1798.84, California residents have the right to request from us a
        list of all third parties to which we have disclosed personal information during the previous year for direct
        marketing purposes. Alternatively, the law stipulates that if a business entity maintains a privacy policy that
        provide users with an “opt-out” mechanism for use of personal information by third parties for their marketing
        purposes, the business entity may as an alternative provide you with information on how you may opt-out from the
        use of information by third parties for direct marketing purposes.
        We have not shared your personal information with any third party for direct marketing purposes. Should you need
        this in writing, you can contact us via the information provided later in this Policy.
        Flashcards does not differentiate or discriminate how we treat our users whether they exercise their rights
        under
        the CCPA.
        <h3>Privacy Shield</h3>
        Flashcards complies with the EU-U.S. Privacy Shield Framework and Swiss-U.S. Privacy Shield Framework as set
        forth
        by the U.S. Department of Commerce regarding the collection, use, and retention of personal information
        transferred from the European Union and Switzerland to the United States. If there is any conflict between the
        terms in this privacy policy and the Privacy Shield Principles, the Privacy Shield Principles shall govern. To
        learn more about the Privacy Shield program, and to view our certification, please visit
        https://www.privacyshield.gov/. No other entities are covered by our certification.
        For EU, Swiss and UK subscribers, Flashcards will comply with the Standard Contractual Clauses (“SCC”) as set
        forth by the provisions of GDPR regarding the collection, use, and retention of personal information from
        European
        Union, Switzerland, and the United Kingdom to the United States. If there is any conflict between the terms of
        this privacy policy and the SCC, SCC shall govern.
        <h4>Recourse, Enforcement, Liability.</h4>
        In compliance with the Privacy Shield Principles and the SCCs, Flashcards commits to resolve complaints about
        our
        collection or use of your personal information. EU, UK and Swiss individuals with inquiries or complaints
        regarding our Privacy Shield policy or the SCCs should first contact Flashcards at privacy@cookiebrains.com.
        Note that Flashcards is subject to investigatory and enforcement powers of the U.S. Federal Trade Commission
        with
        respect to personal data.
        <h3>Changes to This Privacy Policy</h3>
        We may amend this Privacy Policy from time to time. In case of major changes, we will notify users by email
        addresses provided to us.
        If you don’t agree with any changes to the Privacy Policy, you may terminate your account. By continuing to use
        the Site after the revised Privacy Policy has become effective, you acknowledge that you accept and agree to
        the current version of the Privacy Policy.
        Contact Us
        If you have any questions, concerns, or complaints regarding this Policy or our data processing activities,
        please
        contact us by email at privacy@cookiebrains.com.


      </>
      )
      }
